import { collapseRow, expandRow, findInTree } from '../utils/treeSync';
import { TAction, ToggleEvent, TreeItem } from './types';

interface Cache {
  tree: TreeItem[];
  lastToggled: ToggleEvent | undefined;
}

let cache: Cache = {
  tree: [],
  lastToggled: undefined
};

export const initializeTreeCache = (firstLevel: TreeItem[]) => {
  cache = {
    tree: firstLevel,
    lastToggled: undefined
  };
};

export const getVisibleTree = (tree: TreeItem[], lastToggled: ToggleEvent | undefined) => {
  if (lastToggled === undefined) {
    return cache.tree;
  }

  if (cache.lastToggled === lastToggled) {
    return cache.tree;
  }

  let newTree: TreeItem[] = [];

  if (lastToggled.action === TAction.Collapse) {
    const rowIndex = findInTree(cache.tree, lastToggled.treeId);
    newTree = collapseRow(cache.tree, rowIndex);
  }

  if (lastToggled.action === TAction.Expand) {
    const rowIndex = findInTree(cache.tree, lastToggled.treeId);
    newTree = expandRow(tree, cache.tree, rowIndex);
  }

  cache.tree = newTree;
  cache.lastToggled = lastToggled;
  return cache.tree;
};



// WEBPACK FOOTER //
// ./src/store/visibleTreeCache.ts